// TelStyles.js
export default {
  // 主容器样式
  mainContainer: {
    flex: 1,
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'linear-gradient(#494A4F, #1A2120)'
  },

  // 通话信息区域（时间/昵称）
  callInfoContainer: {
    marginTop: 160,
    alignItems: 'center',
    justifyItems: 'center',
    textAlign: 'center'
  },

  // 时间/状态文本样式（通话时长或"正在呼叫"）
  statusText: {
    color: 'rgba(255,255,255,0.5)',
    fontSize: 18
  },

  // 昵称文本样式
  nicknameText: {
    color: '#fff',
    fontSize: 22,
    fontWeight: '700',
    marginTop: 32
  },

  // 底部按钮区域容器
  buttonAreaContainer: {
    position: 'absolute',
    bottom: 74,
    left: 0,
    right: 0
  },

  // 按钮组容器（居中对齐）
  buttonGroup: {
    textAlign: 'center'
  },

  // 单个按钮容器基础样式
  buttonItem: {
    display: 'inline-block',
    alignItems: 'center',
    justifyItems: 'center'
  },

  // 结束按钮额外样式（左侧间距）
  endButton: {
    // marginLeft: 105
  },

  // 按钮图片样式
  buttonImage: {
    width: 70,
    height: 70,
  },

  // 按钮下方文本样式
  buttonText: {
    marginTop: 9,
    fontSize: 14,
    color: '#fff'
  }
};


// WEBPACK FOOTER //
// ./src/modules/tel/TelStyles.js